import styled, { css } from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing, palette } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';

const NavBar = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: var(--navbar-height);
    width: 100%;
    padding: 0 ${spacing("lg")};
    border: none;
    color: ${palette("neutral.0")};
    background-color: ${palette("neutral.900")};
`;
const Brand = styled(Box)`
    display: flex;
    align-items: center;

    ${({ href }) => href && css`
            text-decoration: none;
            transition: color 200ms ease-in;
            color: ${palette("neutral.50")};
            cursor: pointer;

            &:hover {
                color: ${palette("neutral.400")};
            }
        `}
`;
const Menu = styled(Box).attrs(({ justify }) => ({
  justifyContent: justify
}))`
    display: flex;
    flex: 1 1 0;
    align-items: center;
    width: 100%;
`;
const NavBarDrawer = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: var(--navbar-height);
    width: 100%;
    padding: 0 ${spacing("lg")};
    border: none;
    color: ${palette("neutral.0")};
    background-color: ${palette("neutral.900")};

    ${({ theme }) => theme.breakpoint("sm")`
        padding: 0 ${spacing("xs")};
    `}
`;
const Divider = styled.hr`
    border-width: 0px 0px 0px 1px;
    border-image: initial;
    border-color: inherit;
    border-style: solid;
    height: 28px;
    margin: ${spacing("md")};
    color: ${palette("neutral.700")};
`;

export { Brand, Divider, Menu, NavBar, NavBarDrawer };
//# sourceMappingURL=styled.es.js.map
